var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "game-list-tab" },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-listeners": _vm.tableListeners,
        },
        scopedSlots: _vm._u([
          {
            key: "search-tags",
            fn: function ({ query }) {
              return [
                _c("TypeSelect", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "gameTag",
                    placeholder: "选择游戏标签",
                    clearable: "",
                  },
                  model: {
                    value: query.tags,
                    callback: function ($$v) {
                      _vm.$set(query, "tags", $$v)
                    },
                    expression: "query.tags",
                  },
                }),
              ]
            },
          },
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleBatchUpdateStatus(1)
                          },
                        },
                      },
                      [_vm._v("批量开启")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleBatchUpdateStatus(2)
                          },
                        },
                      },
                      [_vm._v("批量关闭")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colTags",
            fn: function ({ row }) {
              return [
                _c("div", { staticClass: "tags-cell-wrap" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tags-cell-text",
                      class: { "is-clamped": _vm.needExpandTags(row.tags) },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.formatTagsDisplay(row.tags)) + " "
                      ),
                    ]
                  ),
                ]),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c("el-switch", {
                  attrs: {
                    size: "mini",
                    "active-value": 1,
                    "inactive-value": 2,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleStatusChange([row.game_id], row.status)
                    },
                  },
                  model: {
                    value: row.status,
                    callback: function ($$v) {
                      _vm.$set(row, "status", $$v)
                    },
                    expression: "row.status",
                  },
                }),
              ]
            },
          },
          {
            key: "colGameIcon",
            fn: function ({ row }) {
              return [
                row.game_icon
                  ? _c("el-image", {
                      staticStyle: {
                        width: "36px",
                        height: "36px",
                        "border-radius": "4px",
                      },
                      attrs: {
                        src: row.game_icon,
                        fit: "cover",
                        "preview-src-list": [row.game_icon],
                      },
                    })
                  : _c("span", [_vm._v("无图片")]),
              ]
            },
          },
          {
            key: "colCreatedAt",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.parseTime(row.created_at)))]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEditGame(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("ManageGameDialog", {
        attrs: {
          "is-visible": _vm.gameDialogVisible,
          "game-data": _vm.currentGame,
        },
        on: {
          "save-success": _vm.handleGameSaveSuccess,
          close: function ($event) {
            _vm.gameDialogVisible = false
          },
        },
      }),
      _c("ManageGameImportDialog", {
        attrs: { "is-visible": _vm.importDialogVisible },
        on: {
          "import-success": _vm.handleImportSuccess,
          close: function ($event) {
            _vm.importDialogVisible = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }